import React from "react";

const Testimonial = () => {
  return (
    <div id="testimonial">
      <h2>Testimonial</h2>

      <section>
       <TestimonialCard
          name={"Pranav K."}
          feedback={"I expected this kind of project from you because you are very hard working."}
        />

        <TestimonialCard
          name={"Abhishek K."}
          feedback={"Your Coding skills are so good."}
        />

        <TestimonialCard
          name={"DMK Raj"}
          feedback={
            "Wow what a portfolio, It's looking worderful!"
          }
        />

      </section>
    </div>
  );
};

const TestimonialCard = ({ name, feedback }) => (
  <article>
    <img
      src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
      alt="User"
    />
    <h4>{name}</h4>
    <p>{feedback}</p>
  </article>
);

export default Testimonial;
